module.exports = __webpack_public_path__ + "static/media/style-detail-arrow.df9caadb.svg";